<app-install-pwa-prompt *ngIf="pwaInstallService.bannerVisible$ | async" />
<router-outlet *ngIf="!isSiteUnderMaintenance"></router-outlet>
<div *ngIf="isSiteUnderMaintenance">
  <temporarily-unavailable></temporarily-unavailable>
</div>
